import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import { Avatar } from '../../../components/ui/Avatar';
import { Button } from '../../../components/ui/Button';
import { Modal } from '../../../components/ui/Modal';
import './connections.css';

interface ConnectionRequestModalProps {
  username: string;
  avatarUrl?: string;
  /** Stable identity so the fallback color matches the member's list row. */
  seed?: string | number | null;
  acceptLoading?: boolean;
  rejectLoading?: boolean;
  onClose: () => void;
  onAccept: () => void;
  onReject: () => void;
}

/** Accept / reject prompt for a pending follow or buddy request. */
export function ConnectionRequestModal({
  username,
  avatarUrl,
  seed,
  acceptLoading = false,
  rejectLoading = false, 
  onClose,
  onAccept,  
  onReject,
}: ConnectionRequestModalProps) {
  const { t } = useTranslation();
  const title = t('connections.request.title', { name: username });

  return (
    <Modal
      title={title}
      onClose={acceptLoading || rejectLoading  ? () => undefined : onClose}
      labelledBy="connection-request-modal-title"
      className="connection-request-modal"
    >
      <div className="connection-request">
        <Avatar src={avatarUrl} name={username} seed={seed} size="xl" />
        <p className="connection-request__message">
          {t('connections.request.description', { name: username })}
        </p>
        <div className="connection-request__actions">
          <Button variant="ghost" size="md" fullWidth onClick={onReject} disabled={acceptLoading || rejectLoading}>
            {t('connections.request.reject')}
          </Button>
          <Button size="md" fullWidth onClick={onAccept} disabled={acceptLoading || rejectLoading}>
            {t('connections.request.accept')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
